import { send } from '../../../../../../src/network/network';
import { type CustomerDishType } from '../../../../../../src/types/CustomerDishType';
import { type PatchedCustomerDishType } from '../../../../../../src/types/PatchedCustomerDishType';

export type { PatchedCustomerDishType };

type Params = {
  requestBody: PatchedCustomerDishType[];
};

export async function patchApiV2CustomersCustomerIdDishTypes({
  requestBody,
}: Params) {
  return await send<CustomerDishType>({
    path: `/api/v2/customers/self/dish_types/`,
    method: 'PATCH',
    body: requestBody,
  });
}
